export default () => `pip install flagsmith
`
